export default "__VITE_ASSET__DXCtDGXW__"